(() => {
  const selector = '[data-baf-scroll-subnav]';
  const state = window.BAFScrollSubnav || {
    navs: new Set(),
    lastScrollY: Math.max(window.scrollY || 0, 0),
    ticking: false,
    measureTicking: false,
    bound: false,
    lenisBound: false,
    hidden: false,
  };

  window.BAFScrollSubnav = state;

  if (typeof state.measureTicking !== 'boolean') state.measureTicking = false;
  if (typeof state.hidden !== 'boolean') state.hidden = false;

  const getNavRoot = (nav) => nav.closest('.artist-collection, .shop-products') || document.documentElement;
  const getCurrentScrollY = () => Math.max(window.scrollY || 0, 0);
  const getCssNumber = (element, property) => (
    element ? parseFloat(window.getComputedStyle(element).getPropertyValue(property)) || 0 : 0
  );

  const getHeaderOffset = () => {
    const root = document.documentElement;
    const header = document.querySelector('#header-component');
    const stickyBar = document.querySelector('#klav-sticky.klav-sticky--bar:not([hidden])');
    // Use stable heights only. Viewport-relative edges can move during native scrolling
    // and make the fixed subnav jump by a pixel or more between frames.
    const headerHeight = Math.max(
      getCssNumber(root, '--baf-stable-header-height'),
      getCssNumber(root, '--header-height'),
      getCssNumber(document.body, '--header-height'),
      header?.getBoundingClientRect().height || 0
    );
    const stickyBarVisible = Boolean(
      stickyBar &&
      root.classList.contains('klav-sticky-as-bar') &&
      root.classList.contains('klav-sticky-visible')
    );
    const stickyBarHeight = stickyBarVisible
      ? Math.max(
        getCssNumber(document.body, '--klav-sticky-bar-height'),
        stickyBar?.getBoundingClientRect().height || 0
      )
      : 0;

    return Math.max(0, headerHeight + stickyBarHeight);
  };

  const revealAtTop = () => {
    if (getCurrentScrollY() > 4) return;

    state.hidden = false;
    state.lastScrollY = 0;
    state.navs.forEach((nav) => {
      if (!document.documentElement.contains(nav)) {
        state.navs.delete(nav);
        return;
      }
      nav.classList.remove('is-hidden-on-scroll');
    });
  };

  const measureNavs = () => {
    const headerOffset = getHeaderOffset();

    state.navs.forEach((nav) => {
      if (!document.documentElement.contains(nav)) {
        state.navs.delete(nav);
        return;
      }

      const root = getNavRoot(nav);
      const height = Math.ceil(nav.getBoundingClientRect().height);
      const topValue = `${headerOffset}px`;
      const heightValue = `${height}px`;

      if (root.style.getPropertyValue('--baf-scroll-subnav-top') !== topValue) {
        root.style.setProperty('--baf-scroll-subnav-top', topValue);
      }
      if (height > 0 && root.style.getPropertyValue('--baf-scroll-subnav-height') !== heightValue) {
        root.style.setProperty('--baf-scroll-subnav-height', heightValue);
      }
    });
  };

  const queueMeasureNavs = () => {
    if (state.measureTicking) return;
    state.measureTicking = true;
    window.requestAnimationFrame(() => {
      state.measureTicking = false;
      measureNavs();
    });
  };

  document.querySelectorAll(selector).forEach((nav) => {
    if (nav instanceof HTMLElement) {
      state.navs.add(nav);
      nav.classList.toggle('is-hidden-on-scroll', state.hidden);
    }
  });

  revealAtTop();
  queueMeasureNavs();

  if (state.bound) return;
  state.bound = true;

  const threshold = 6;

  const setHidden = (hidden) => {
    state.hidden = hidden;
    state.navs.forEach((nav) => {
      if (!document.documentElement.contains(nav)) {
        state.navs.delete(nav);
        return;
      }
      nav.classList.toggle('is-hidden-on-scroll', hidden);
    });
  };

  const updateFromScrollY = (currentScrollY) => {
    const delta = currentScrollY - state.lastScrollY;

    if (currentScrollY <= 4 || delta < -threshold) {
      setHidden(false);
    } else if (delta > threshold) {
      setHidden(true);
    }

    state.lastScrollY = currentScrollY;
  };

  const update = () => {
    updateFromScrollY(Math.max(window.scrollY || 0, 0));
    state.ticking = false;
  };

  const onScroll = () => {
    if (state.ticking) return;
    state.ticking = true;
    window.requestAnimationFrame(update);
  };

  window.addEventListener('scroll', onScroll, { passive: true });
  window.addEventListener('resize', queueMeasureNavs, { passive: true });
  window.addEventListener('orientationchange', queueMeasureNavs, { passive: true });
  window.visualViewport?.addEventListener('resize', queueMeasureNavs, { passive: true });
  window.addEventListener('pageshow', () => {
    revealAtTop();
    queueMeasureNavs();
  });

  if (window.MutationObserver) {
    const observer = new MutationObserver(queueMeasureNavs);
    observer.observe(document.documentElement, { attributes: true, attributeFilter: ['class', 'style'] });
    observer.observe(document.body, { attributes: true, attributeFilter: ['class', 'style'] });
    state.headerMutationObserver = observer;
  }

  if (window.ResizeObserver) {
    const resizeObserver = new ResizeObserver(queueMeasureNavs);
    const header = document.querySelector('#header-component');
    const headerSection = header?.closest('.header-section');
    const stickyBar = document.getElementById('klav-sticky');

    [header, headerSection, stickyBar].forEach((element) => {
      if (element) resizeObserver.observe(element);
    });
    state.headerResizeObserver = resizeObserver;
  }

  const bindLenis = () => {
    const lenis = window.BarkFrameLenis;
    if (state.lenisBound || !lenis?.on) return;

    state.lenisBound = true;
    lenis.on('scroll', ({ scroll, direction }) => {
      const currentScrollY = Math.max(scroll || window.scrollY || 0, 0);

      if (currentScrollY <= 4 || direction < 0) {
        setHidden(false);
      } else if (direction > 0) {
        setHidden(true);
      }

      state.lastScrollY = currentScrollY;
    });
  };

  bindLenis();
  document.addEventListener('DOMContentLoaded', bindLenis, { once: true });
  window.addEventListener('load', bindLenis, { once: true });
  document.addEventListener('DOMContentLoaded', queueMeasureNavs, { once: true });
  window.addEventListener('load', queueMeasureNavs, { once: true });
  document.fonts?.ready?.then(queueMeasureNavs);
})();
